<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'contenttitle',
})
</script>
<template>
      <div  class="content-title" v-if="data.showtitle>0">
          <h2 class="flex align-center">
            <span class="flex1">{{ data.name }}</span>
            <a :href="data.url" v-if="data.url"><ArrowRightOutlined  /></a>
          </h2>
          <h4 v-if="data.sub">{{ data.sub }}</h4>
      </div>
</template>
<script setup lang="ts" name="contenttitle">
import {defineComponent,defineProps,ref } from 'vue'
import {addip,getCol} from '@/utils/util'
import {ArrowRightOutlined} from '@ant-design/icons-vue'
defineProps({
  data:Object
})
</script>
